import { constantTree } from "../../../core/events/ConstantTree";

export const touTree = constantTree({
    Content: {
        Get: ""
    }
})